import React from 'react';
import { NamedLink } from '../../../components';
import IconArrowTop from '../../../components/IconArrowTop/IconArrowTop';
import moment from 'moment';
import { draftSlug } from '../../../routing/routeConfiguration';

import css from '../SingleBlogPage.module.css';

function SingleBlogCards(props) {
  const { blog } = props;

  const blogImages = blog?.coverImage?.url;
  const tag = blog?.tag?.data?.attributes?.name;
  const title = blog?.title;
  const createdAt = blog?.createdAt;
  const slug = blog?.slug;

  return (
    <NamedLink className={css.blog} name="SingleBlogPage" params={{ title: slug || draftSlug }}>
      <div className={css.blogImg}>{blogImages && <img src={blogImages} alt={title} />}</div>
      <div className={css.blogDetails}>
        <div className={css.blogPostTime}>
          <div className={css.tagContainer}>
            <span className={css.blogTime}>{tag}</span>
          </div>
          <span className={css.blogTime}>{moment(createdAt).format('DD/MM/YYYY')}</span>
        </div>
        <div className={css.cardTitleSec}>
          <h2 className={css.blogPostTitle}>{title}</h2>
          <IconArrowTop />
        </div>
      </div>
    </NamedLink>
  );
}

export default SingleBlogCards;
